import { AxiosRequestConfig } from "axios";
import ApiService from "../utils/api-services";

class UserService extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: `${process.env.REACT_APP_BASE_LOCALY_URL}/api`,
      ...config,
    });
  }

  public GetUserById = async (id: any): Promise<any> => {
    return await this.get(`/services/app/User/Get?id=${id}`);
  };

  public getUsersWithPagination = async (
    selectedValue: number,
    keyword: any,
    SkipCount: any,
    UserType: any,
    MinistryId: any
  ): Promise<any> => {
    return await this.get(
      `/services/app/User/GetAll?MaxResultCount=${selectedValue}&SkipCount=${SkipCount}&Keyword=${keyword}&UserType=${UserType}&MinistryId=${MinistryId}`
    );
  };

  public getLeadersWithPagination = async (
    selectedValue: number,
    keyword: any,
    SkipCount: any,
    UserType: any,
    DepartmentId: any
  ): Promise<any> => {
    return await this.get(
      `/services/app/User/GetAll?MaxResultCount=${selectedValue}&SkipCount=${SkipCount}&Keyword=${keyword}&UserType=${UserType}&DepartmentId=${DepartmentId}`
    );
  };

  public getEmployeesWithPagination = async (
    selectedValue: number,
    keyword: any,
    SkipCount: any,
    UnitId: any
  ): Promise<any> => {
    return await this.get(
      `/services/app/User/GetAll?MaxResultCount=${selectedValue}&SkipCount=${SkipCount}&Keyword=${keyword}&UserType=${3}&UnitId=${UnitId}`
    );
  };

  public getUsersWithoutPagination = async (): Promise<any> => {
    return await this.get(`/services/app/User/GetAll`);
  };

  public AddUser = async (body: any): Promise<any> => {
    return await this.post("/services/app/User/Create", body);
  };

  public EditUser = async (body: any): Promise<any> => {
    return await this.put("/services/app/User/Update", body);
  };

  public DeleteUser = async (id: any): Promise<any> => {
    return await this.delete(`/services/app/User/Delete?Id=${id}`);
  };
}

export const Users = new UserService();
